const defaultState = {
    activeProductList: [],
    activeAssortmentIndex: 0,
};

const state = defaultState;

const mutations = {
    resetState: state => Object.assign(state, defaultState),
    setProductList: (state, products) => state.activeProductList = products,
    setActiveAssortmentIndex: (state, assortmentIndex) => state.activeAssortmentIndex = assortmentIndex,
};

const actions = {
    resetState: ({ commit }) => commit('resetState'),
    setProductList: ({ commit }, assortment) => commit('setProductList', assortment),
    setActiveAssortmentIndex: ({ commit }, assortmentIndex) => commit('setActiveAssortmentIndex', assortmentIndex),
};

const getters = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
